"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pipeA = exports.default = void 0;
var _ = require(".");
const pipe = (value, ...fns) => fns.reduce((val, fn) => fn(val), value);
const pipeA = (value, ...fns) => fns.reduce((val, fn) => (0, _.isPromise)(val) ? val.then(fn) : fn(val),
//
value //
);
exports.pipeA = pipeA;
pipe.async = pipeA;
var _default = pipe;
exports.default = _default;